import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';

export enum KeyFileType {
    LOTUS_NOTES = 'LOTUS_NOTES',
    BIT_LOCKER = 'BIT_LOCKER'
}

export class KeyFileViewModel extends DrObject {

    model:  Partial<KeyFile>;

    constructor(value?: Partial<KeyFile>) {
        super(DrObjectType.LOTUS_NOTES);
        if (value) {
            this.model = value;
        }
    }
}

export class KeyFile extends DrEntity {
    name:         string;
    description:  string;
    dateUploaded: string;
    uploadedBy: string;
    fileName: string;
    filePassword: string;
    type: string;
    typeDisplay: string;

    constructor(value?: Partial<KeyFile>) {
        super(value);
        if (value) {
            Object.assign(this, value);

            if (this.type) {
                switch (this.type) {
                    case KeyFileType.BIT_LOCKER: this.typeDisplay = 'MS BitLocker'; break;
                    case KeyFileType.LOTUS_NOTES: this.typeDisplay  = 'Lotus Notes'; break;
                }
            }
        }
    }
}
